<template>
  <div class="home">
    <!-- <transition name="fade">
      <div :class="headColor" v-show="show">
        @click="trigger()" v-voluntarily
        <Header></Header>
      </div>
    </transition> -->

    <div class="head1">
      <Header></Header>
    </div>

    <div class="subject">
      <Content></Content>
    </div>

    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
import Content from "@/views/content/Content.vue";
export default {
  components: { Header, Footer, Content },
  data() {
    return {
      scrollTop: null,
      headColor: null,
      // show: true,
      // show: false,
      num: null,
    };
  },
  created() {
    // this.headColor = "head1";
    this.$store.state.menu = 1;
  },
  mounted() {
    // window.addEventListener("scroll", this.one);
  },
  methods: {
    // one() {
    //   let scrollTop = document.documentElement.scrollTop;
    //   // console.log("动了", scrollTop);
    //   if (scrollTop >= 100) {
    //     this.headColor = "head1";
    //     this.show = true;
    //   } else if (scrollTop < 100) {
    //     this.headColor = "head";
    //     this.show = false;
    //   }
    // },
    // trigger() {
    //   if (this.$store.state.first == null) {
    //     // console.log("能吗");
    //     this.show = false;
    //   } else {
    //     console.log("no");
    //   }
    //   this.$store.state.first++;
    // },
  },
  // directives: {
  //   voluntarily: {
  //     // 指令的定义
  //     inserted: function (el) {
  //       // console.log(el, "ffffff");
  //       el.click();
  //     },
  //   },
  // },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.home {
  width: 100%;
  // .head {
  //   position: fixed;
  //   width: 100%;
  //   height: 100px;
  //   z-index: 5;
  //   color: #fff;
  // }
  .head1 {
    position: fixed;
    width: 100%;
    height: 100px;
    z-index: 5;
    color: #333;
    background-color: #fff;
    z-index: 20;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
  .subject {
    width: 100%;
  }
  .foot {
    width: 100%;
  }
  // .fade-enter-active,
  // .fade-leave-active {
  //   transition: opacity 0.5s;
  // }
  // .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  //   opacity: 0;
  // }
}
</style>
